<script setup>
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel';
import { ref } from 'vue';
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/vue/24/outline';
import AnimatedComponent from '@/Components/AnimatedComponent.vue';
import TeamMemberItem from './TeamMemberItem.vue';

defineProps({
    members: {
        type: Array,
        required: true,
    },
});

const currentSlide = ref(0);

const sliderBreakpoints = ref({
    768: {
        itemsToShow: 3.5,
        snapAlign: 'center',
    },
});

const slidePrev = () => {
    currentSlide.value -= window.innerWidth >= 768 ? 3 : 1;
};

const slideNext = () => {
    currentSlide.value += window.innerWidth >= 768 ? 3 : 1;
};
</script>

<template>
    <section class="overflow-x-hidden px-6 py-12 md:py-17">
        <div class="container max-w-7xl mx-auto">
            <div class="w-full flex flex-col justify-between items-center text-center gap-6 md:flex-row md:gap-0">
                <h2
                    class="text-3xl text-[#272529]"
                    v-text="__('page.home.team.title')"
                />

                <div class="flex items-center justify-center gap-4 mt-6">
                    <button
                        class="h-10 w-10 flex items-center justify-center border border-[#D3DBD1] rounded-full"
                        @click="slidePrev"
                    >
                        <ArrowLeftIcon class="h-4 w-4 text-[#55554E]"/>
                    </button>

                    <button
                        class="h-10 w-10 flex items-center justify-center border border-[#D3DBD1] rounded-full"
                        @click="slideNext"
                    >
                        <ArrowRightIcon class="h-4 w-4 text-[#55554E]"/>
                    </button>
                </div>
            </div>

            <AnimatedComponent type="zoom">
                <Carousel
                    v-model="currentSlide"
                    :items-to-show="1"
                    :breakpoints="sliderBreakpoints"
                    class="mt-6 md:-mx-3"
                    @slide-end="console.log('asd')"
                >
                    <Slide
                        v-for="member in members"
                        :key="member.id"
                    >
                        <TeamMemberItem :member="member"/>
                    </Slide>
                </Carousel>
            </AnimatedComponent>
        </div>
    </section>
</template>

<style>
@media (min-width: 768px) {
    section.carousel .carousel__viewport .carousel__slide {
        padding-left: 12px;
        padding-right: 12px;
    }
}
</style>
